import React from 'react';

import PropTypes from 'prop-types';

import { Container } from './styles';
const HeaderTotalGraphic = ({ title, description, small, marginBottom, align, background, border, height }) => {
    return (
        <Container small={small} marginBottom={marginBottom} align={align} background={background} border={border} height={height}>
            <h2>{title}</h2>
            <h1>{description}</h1>
        </Container>
    );
};

HeaderTotalGraphic.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    marginBottom: PropTypes.string,
    small: PropTypes.bool,
    align: PropTypes.string,
    background: PropTypes.string,
    border: PropTypes.string,
    height: PropTypes.string
};

export default HeaderTotalGraphic;
